import SingleLineText from '../../../ReadOnlyComponents/SingleLineText/SingleLineText'
import { InputField, FormError } from '../../../../../Common/Form'
import _ from 'lodash'
import styles from './ProductSizeFields.css'

const ProductSizeFields = props => {
  const {
    setting,
    readOnly,
    product: { length, width, height },
    isNewProposal,
    mustShowFormError
  } = props

  if (readOnly) {
    return (
      <SingleLineText
        content={`${length.input.value} x ${width.input.value} x ${height.input.value} cm`}
      />
    )
  }

  const checkFields = [length, width, height]
  const isFieldsHasValue = _.some(checkFields, ({ input }) => !_.isEmpty(input.value))
  const isFieldsInvalid = _.some(checkFields, ({ meta }) => meta.invalid)
  // 決定並排長寬高輸入匡是否顯示紅匡
  const isShowErrorOnActive = isNewProposal
    // 新的提案
    ? mustShowFormError
      // 按過送出 mustShowFormError 會變成 true，所以設定成有 error 直接顯示紅匡
      ? true
      // 未送出前，欄位需要為驗證失敗且其中一列有值才顯示紅匡
      : !(isFieldsInvalid && isFieldsHasValue)
    // 複製的提案
    : false
  const showFormError = (
    // 送出後如果有錯誤直接顯示錯誤
    mustShowFormError ||
    (
      // 如果沒有觸發才需要顯示錯誤，預設直接顯示錯誤
      !isShowErrorOnActive ||
      // 欄位修改過或是被觸發過，預設直接顯示錯誤
      checkFields
        .map(({ meta }) => meta)
        .some(({ touched, dirty }) => touched || dirty)
    )
  )
  const productSizeError = _.get(setting, '_productSize.meta.error')

  return (
    <div
      data-role='product-size-fields'
      className={styles.ProductSizeFields}
    >
      <InputField
        key='length'
        hasFormErrorTag={false}
        showErrorOnActive={isShowErrorOnActive}
        mustShowFormError={mustShowFormError}
        data-role='product-length'
        {...length}
        placeholder='長'
      />
      <InputField
        key='width'
        hasFormErrorTag={false}
        showErrorOnActive={isShowErrorOnActive}
        mustShowFormError={mustShowFormError}
        data-role='product-width'
        {...width}
        placeholder='寬'
      />
      <InputField
        key='height'
        hasFormErrorTag={false}
        showErrorOnActive={isShowErrorOnActive}
        mustShowFormError={mustShowFormError}
        data-role='product-height'
        {...height}
        placeholder='高'
        addonAfter='cm'
      />
      <FormError
        key='productSizeError'
        showFormError={showFormError}
        error={productSizeError}
        showErrorOnActive={isNewProposal}
      />
    </div>
  )
}

export default ProductSizeFields
